import { faker } from '@faker-js/faker'

export const SITE_NAMES_MOCK = {
  site0: { name: faker.lorem.words(2) },
  site1: { name: faker.lorem.words(2) },
}
